import { apiFunction } from "../../apiCall/function";
import * as URLs from '../../v2/apiCall/urls'
import * as  APIMaster from "../../apiCall/urls/common"

// get master data 
export const getMasterData = (data) => {
    return apiFunction(APIMaster.MASTER, "post", data, false, null);
}

//beo student list
export const getStudentListV2 = (data) => {
    return apiFunction(URLs.STUDENT_LIST, "POST", data, true, null, "AuthAdmin");
};
// beo action approve 
export const approveStudentV2 = (studentId, session) => {
    return apiFunction(`${URLs.BEO_ACCEPT}${studentId}/${session}`, "POST", null, true, null, "AuthAdmin");
};
// beo action reject
export const rejectStudentV2 = (studentId, data, session) => {
    return apiFunction(`${URLs.BEO_REJECT}${studentId}/${session}`, "POST", data, true, null, "AuthAdmin");
};
//student details beo
export const getStudentDetailBeoV2 = (studentId) => {
    return apiFunction(URLs.BLOCK_STUDENT_ID + "/" + studentId, "post", null, true, null, "AuthAdmin");
};

//deo block list
export const getDistrictBlockListV2 = (data) => {
    return apiFunction(URLs.DISTRICT_BLOCK_LIST, "POST", data, true, null, "AuthAdmin");
};

//deo student list
export const getDistrictStudentListV2 = (data, id) => {
    return apiFunction(`${URLs.DISTRICT_STUDENT_LIST}${id}`, "POST", data, true, null, "AuthAdmin");
};
//student details deo
export const getStudentDetailDeoV2 = (studentId) => {
    return apiFunction(URLs.DISTRICT_STUDENT_ID + "/" + studentId, "post", null, true, null, "AuthAdmin");
};

//state district list
export const getStateDistrictListV2 = (data, role) => {
    let url = role === "division" ? URLs.DIVISION_DISTRICT_LIST : URLs.DISTRICT_LIST
    return apiFunction(url, "POST", data, true, null, "AuthAdmin");
};
// state block list
export const getStateBlockV2 = (districtId, sessionId, role) => {
    let url = role === "division" ? URLs.DIVISION_STATE_BLOCK_LIST : URLs.STATE_BLOCK_LIST
    return apiFunction(`${url}${districtId}`, "post", { sessionId }, true, null, "AuthAdmin");
};
// state student list
export const getStateStudentListV2 = (data, blockId) => {

    return apiFunction(`${URLs.STATE_STUDENT_LIST}${blockId}`, "post", data, true, null, "AuthAdmin");
};
// state student Details
export const getStateStudentIdV2 = (studentId) => {
    return apiFunction(URLs.STATE_STUDENT_ID + "/" + studentId, "post", {}, true, null, "AuthAdmin");
};
// state student rollback
export const stateStudentRollback = (studentId, data, sessionId) => {
    return apiFunction(URLs.STUDENT_ROLL_BACK + studentId + "/" + sessionId, "post", data, true, null, "AuthAdmin");
};


// school rollback 
export const rollbackSchoolApplication = (studentId, data) => {
    return apiFunction(URLs.ROLLBACK_SCHOOL + studentId, "post", data, true, null, "AuthAdmin");
}


// studentRollback 
export const stateRollbackStudent = (studentId, data) => {
    return apiFunction(URLs.ROLLBACK_STUDENT + studentId, "post", data, true, null, "AuthAdmin");
}


// student search 
// (url, method, postData, token, extraConfig, section, extraHeader)
export const searchStudentById = (data) => {
    return apiFunction(URLs.STUDENT_SEARCH, "POST", data, true, null, "AuthAdmin")
}

// Create school by state 
export const createSchool = (data) => {
    return apiFunction(URLs.CREATE_SCHOOL_BY_STATE, "post", data, true, null, "AuthAdmin");
}
// get school list 
export const getSchoolList = (data) => {
    return apiFunction(URLs.GET_SCHOOL_LIST_BY_STATE, "post", data, true, null, "AuthAdmin");
}

// enable school by state 
export const enableSchool = (schoolId) => {
    return apiFunction(`${URLs.ENABLE_SCHOOL_BY_STATE}${schoolId}`, "post", null, true, null, "AuthAdmin");
}

// disabled school  by state 
export const disableSchool = (schoolId, data) => {
    return apiFunction(`${URLs.DISABLE_SCHOOL_BY_STATE}${schoolId}`, "DELETE", data, true, null, "AuthAdmin");
}

// update school details
export const updateSchoolDetails = (schoolId, data) => {
    return apiFunction(`${URLs.UPDATE_SCHOOL_DETAILS_BY_STATE}${schoolId}`, "put", data, true, null, "AuthAdmin");
}

// schoool 
//get all student
export const getSchoolStudentListV2 = (data) => {
    return apiFunction(`${URLs.SCHOOL_STUDENT_LIST}`, "POST", data, true, null, "AuthAdmin");
};
//getStudent Details 
export const getStudentDetailSchool2 = (studentId) => {
    return apiFunction(URLs.SCHOOL_STUDENT_DETAILS + "/" + studentId, "post", null, true, null, "AuthAdmin");
};
// accept student 
export const admittedStudentBySchoolV2 = (id, session) => {
    return apiFunction(`${URLs.ADMITTED_STUDENT_SCHOOL}${id}/${session}`, "POST", null, true, null, "AuthAdmin");
};
// reject student
export const notAdmittedStudentBySchoolV2 = (id, data, session) => {
    return apiFunction(`${URLs.NOT_ADMITTED_STUDENT_SCHOOL}${id}/${session}`, "POST", data, true, null, "AuthAdmin");
};

//  optimize api call 
export const saveSchoolDetails = (payload, isUpdate = false) => {
    const url = isUpdate ? URLs.UPDATE_SCHOOL_DETAILS : URLs.ADD_SCHOOL_DETAILS;
    const method = isUpdate ? "PUT" : "POST";

    // If payload is an instance of FormData, pass "formData" to apiFunction
    const configType = payload instanceof FormData ? "formData" : null;

    return apiFunction(url, method, payload, true, configType, "AuthAdmin");
}


// get schoolDetails 
export const getSchoolDetails = () => {
    return apiFunction(`${URLs.GET_SCHOOL_DETAILS}`, "GET", "null", true, null, "AuthAdmin");
}


// student  actions log  beo and deo common 
export const getStudentActionsLog = (studentId) => {
    return apiFunction(`${URLs.BEO_DEO_ACTIONS_LOG}${studentId}`, "get", "null", true, null, "AuthAdmin");
}

// beo edit student 
export const beoStudentEdit = (data) => {
    return apiFunction(`${URLs.EDIT_STUDENT}`, "POST", data, true, null, "AuthAdmin");
}

//  get list of edit request 
export const getListOfEditRequest = (data) => {
    return apiFunction(`${URLs.GET_LIST_OF_EDIT_REQUEST}`, "post", data, true, null, "AuthAdmin");
}

//--------------DEO STUDENT Verification--------------------- 
// actions log 
export const getDistrictStudentActionsLog = (studentId) => {
    return apiFunction(`${URLs.GET_ACTIONS_LOG_DEO}${studentId}`, "get", "null", true, null, "AuthAdmin");
}
// get Student Edit Request
export const getStudentEditRequest = (data) => {
    return apiFunction(`${URLs.GET_STUDENT_REQUEST}`, "POST", data, true, null, "AuthAdmin");
}

// approve Student Edit Request 
export const approveStudentEditRequest = (data) => {
    return apiFunction(`${URLs.APPROVE_STUDENT_EDIT_REQUEST}`, "POST", data, true, null, "AuthAdmin");
}

// reject  Student Request 
export const rejectApproveStudentRequest = (data) => {
    return apiFunction(`${URLs.REJECT_APPROVE_STUDENT_REQUEST}`, "POST", data, true, null, "AuthAdmin");
}

// ------------------ Common ---------------------- 
// get master session 
export const getMasterAllSession = () => {
    return apiFunction(`${URLs.GET_MASTER_SESSION}`, "get", "null", true, null, "AuthAdmin");
}

//  landing page contact us 
export const postContactUsLandingPage = (data) => {
    return apiFunction(`${URLs.CONTACT_US_LANDING_PAGE}`, "POST", data, false, null, "AuthAdmin");
}

// ---------------------- Admin: Inquiry / Contact Management ----------------------

// get all contact inquiries with pagination — GET /contact?page=1&limit=20
export const getContactInquiryList = (page = 1, limit = 20) => {
    return apiFunction(`${URLs.GET_CONTACT_INQUIRY_LIST}?page=${page}&limit=${limit}`, "GET", null, true, null, "AuthAdmin");
}

// mark inquiry as read  — PUT /contact/read  { id }
export const markContactInquiryRead = (id) => {
    return apiFunction(`${URLs.MARK_CONTACT_INQUIRY_READ}`, "PUT", { id }, true, null, "AuthAdmin");
}